<section>
  <kl-geo-location-marker-common></kl-geo-location-marker-common>
</section>
